OT.createNS('OT.Common.LoadBannerEmblem');

OT.Common.LoadBannerEmblem = (function () {
    'use strict';

    var init = function () {
        $("#emblem").one('load', function () {
            $(this).removeClass('hide');
            $(".needs-emblem-offset").addClass("emblem-offset");
        });
        $("#emblem").attr("src", $("#emblem").attr("data-src"));
    };

    return {
        init: init,
    };

})();